import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Typography, Input, Button, Select, Form, Col, Row, DatePicker, message, Table, Radio, Popconfirm } from "antd";
import moment from "moment";
import { platformApi } from "../../../../../api";
import { getUUID } from "../../../../../_helpers/utils";
import GSTTable from "./GSTTable";
import { GST18, GST28, GST12, GST5 } from "../../../../../utils";
import "./index.less";
import WrappedCustomerAddModal from "../AddCustomer";
import WrappedCustomerUpdateModal from "../../../JobOrder/JobOrderModal/VehicleDetails/UpdateCustomer";
import { ContextAPI } from "../../../../../ContextAPI";
import { useBranch } from "../../../../../ContextAPI/branch";

const { Item } = Form;
const { Option } = Select;
const { Group } = Radio;
const { Title, Text } = Typography;

const formatPhones = (contacts) =>
	(contacts || []).map((c) => c?.phone).filter(Boolean).join(" / ");

const formatCustomerLabel = (name, contacts) =>
	`${name || ""} - ${formatPhones(contacts)}`;

const InvoiceForm = (props) => {
	const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
	const history = useHistory();
	const location = useLocation();
	const {
		customer,
		setValidCustomer,
		form,
		id,
		editData,
		editable,
		onEdit,
		modifyType,
		setSearch,
		setPartSearch,
		partsData,
		setPartsData,
		jobCode,
		setJobCode,
		jobNo,
		setJobNo,
		initialData,
		isCEO,
		modifyAccess,
	} = props;
	const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
	const partItemData = {
		id: getUUID(),
		partNumber: {},
		hsn: {},
		quantity: "",
		unitRate: "",
		discount: "",
		rate: "",
		igst: 0,
		cgst: 0,
		sgst: 0,
		gstRate: 0,
		grandTotal: 0,
		igstAmount: 0,
		cgstAmount: 0,
		sgstAmount: 0,
		discountAmount: 0,
		discountPercent: 0,
		remove: "",
	};

	const { loginCredintials } = useContext(ContextAPI);
	const { selectBranch, nearestBranch } = useBranch();
	const [selectedPart, setSelectedPart] = useState("");
	const [itemList, setItemList] = useState([partItemData]);
	const [selectItemObj, setSelectItemObj] = useState({});
	const [invoiceNumber, setInvoiceNumber] = useState();
	const [gst, setGst] = useState();
	const [model, setModel] = useState();
	const [invoiceDate, setInvoiceDate] = useState();
	const [customerID, setCustomer] = useState();
	const [discountLevel, setDiscountLevel] = useState();
	const [tax, setTax] = useState("Tax Exclusive");
	const [discountType, setDiscountType] = useState("At Transaction Level");
	const [quantity, setquantity] = useState();
	const [unitRate, setUnitRate] = useState();
	const [rate, setRate] = useState(0);
	const [discountAmount, setDiscountAmount] = useState(0);
	const [discount, setDiscount] = useState(0);
	const [totalDiscount, setTotalDiscount] = useState(0);
	const [grandTtl, setGrandTotal] = useState(0);
	const [adjustments, setAdjustments] = useState(0);
	const [totalInvoice, setTotalInvoice] = useState();
	const [invoiceType, setInvoiceType] = useState("counterSale");
	const [stateName, setStateName] = useState();
	const [SGST, setSGST] = useState();
	const [CGST, setCGST] = useState();
	const [IGST, setIGST] = useState();
	const [GSTRate18, setGSTRate18] = useState(false);
	const [GSTRate28, setGSTRate28] = useState(false);
	const [GSTRate12, setGSTRate12] = useState(false);
	const [GSTRate5, setGSTRate5] = useState(false);
	const [SGSTAmount, setSGSTAmount] = useState();
	const [CGSTAmount, setCGSTAmount] = useState();
	const [IGSTAmount, setIGSTAmount] = useState();
	const [TCS, setTCS] = useState(0);
	const [deleteItem, setDeleteItem] = useState(false);
	const [formSubmit, setFormSubmit] = useState(false);
	const [error, setError] = useState({});
	const [number, setNumber] = useState();
	const [invoiceNo, setInvoiceNo] = useState("");
	const [modalOpen, setModalOpen] = useState(false);
	const [modalOpen2, setModalOpen2] = useState(false);
	const [temp, setTemp] = useState(false);
	const [selected, setSelected] = useState(null);
	const [cusId, setCusId] = useState("");
	const [newCustomer, setNewCustomer] = useState(null);
	const [selectedCustomer, setSelectedCustomer] = useState();
	const [selectPart, setSelectPart] = useState();
	const [convertedTCS, setConvertedTCS] = useState();
	const [branch, setBranch] = useState({ id: "", name: "" });
	const [dataTemp, setDataTemp] = useState([]);
	const [btnFlag, setBtnFlag] = useState(false);
	const [deleteData, setDeleteData] = useState([]);
	const [pid, setPid] = useState([]);
	const [jid, setJid] = useState([]);
	const [SAC, setSAC] = useState([]);
	const [deletePartData, setDeletePartData] = useState([]);
	const [quantityValidation, setQuantityValidation] = useState({});
	const [spareInventory, setSpareInventory] = useState({});
	const [initialPartDetails, setInitialPartDetails] = useState({});
	const [updatedSpareDetails, setUpdatedSpareDetails] = useState({});
	const [searching, setSearching] = useState(false);
	const searchTimeoutRef = useRef(null);
	const partsRef = {};
	let totalAdjustments = 0;
	let grandTotal = 0;
	let tcs = 0;
	let sgstAmt = 0;
	let cgstAmt = 0;
	let igstAmt = 0;

	useEffect(() => {
		const obj = {};
		for (const item of itemList) {
			if (item.partNumber && item.partNumber.id) {
				obj[item.partNumber.id] = true;
			}
		}
		setSelectItemObj(obj);
	}, [itemList]);

	useEffect(() => {
		if (location.state) {
			setGst(location.state.gst);
		}
	}, [location.state]);

	// Party GSTIN only when registered (missing → local CGST/SGST)
	useEffect(() => {
		const gstType = String(selectedCustomer?.GSTType || "").toUpperCase();
		const isRegistered =
			(gstType.includes("REGISTERED") || gstType.includes("COMPOSITION")) &&
			!gstType.includes("UNREGISTERED");
		const customerGst = String(selectedCustomer?.GSTNo || "").trim();
		setStateName(isRegistered && customerGst ? customerGst : "");
	}, [selectedCustomer]);

	useEffect(() => {
		if (partsData || jobCode) {
			const combined = [
				...(partsData || []).filter(item => item && item.id).map((item) => ({
					label: `${item.partNumber} - ${item.partName}`,
					value: item.partNumber,
					id: item.id,
				})),
				...(jobCode || []).filter(item => item && item.id).map((item) => ({
					label: item.description ? `${item.code} - ${item.description}` : item.code,
					value: item.code,
					id: item.id,
					consumable: item.consumable,
				})),
			];

			const unique = combined.filter(
				(item, index, self) => index === self.findIndex((t) => t.id === item.id)
			);
			setDataTemp(unique);
		}
	}, [partsData, jobCode]);

	useEffect(() => {
		if (editData) {
			setInvoiceNumber(editData.invoiceNumber || null);
			setInvoiceNo(editData.invoiceNumber || null);
			setInvoiceDate(
				editData && editData.invoiceDate
					? moment(new Date(editData.invoiceDate && editData.invoiceDate)).format("YYYY-MM-DD")
					: null
			);
			setDiscountType(editData.discountType);
			setInvoiceType(editData.invoiceType || null);
			setTax(editData.itemRate);
			setTCS(editData.tcs);
			setAdjustments(editData.adjustment);
			setCustomer(editData && editData.partyName ? formatCustomerLabel(editData.partyName.name, editData.partyName.contacts) : "");
			setNewCustomer(editData && editData.partyName?.id);
			setSelectedCustomer(editData.partyName);
			if (editData.discountType === "At Transaction Level") {
				if (editData.discountPercent !== 0) {
					setDiscountAmount(editData.discountPercent);
					setDiscountLevel("percent");
				}
				if (editData.discountRate !== 0) {
					setDiscountAmount(editData.discountRate);
					setDiscountLevel("rupee");
				}
			}
			setTotalDiscount(editData.totalDiscount);
			setTotalInvoice(editData.totalInvoice);

			const updateItemList = [...editData.saleItemInvoice];

			for (let i = 0; i < updateItemList.length; i++) {
				if (updateItemList[i].jobCode) {
					updateItemList[i].partNumber = { ...updateItemList[i] };
					updateItemList[i].partNumber.code = updateItemList[i].partName;
					updateItemList[i].rate = updateItemList[i].quantity * updateItemList[i].unitRate;
					(updateItemList[i].hsn = updateItemList[i].sac), (updateItemList[i].cgst = updateItemList[i].sac.cgst);
					updateItemList[i].sgst = updateItemList[i].sac.sgst;
					updateItemList[i].igst = updateItemList[i].sac.igst;
					updateItemList[i].gstRate = updateItemList[i].sac.cgst + updateItemList[i].sac.sgst;
					updateItemList[i].gstRate = updateItemList[i].igst;

					setUnitRate(updateItemList[i].unitRate);
					if (updateItemList[i].gstRate === GST28) {
						setGSTRate28(true);
					}
					if (updateItemList[i].gstRate === GST18) {
						setGSTRate18(true);
					}
					if (updateItemList[i].gstRate === GST12) {
						setGSTRate12(true);
					}
					if (updateItemList[i].gstRate === GST5) {
						setGSTRate5(true);
					}
				} else {
					updateItemList[i].rate = updateItemList[i].quantity * updateItemList[i].unitRate;
					updateItemList[i].gstRate = updateItemList[i].igst;
					setUnitRate(updateItemList[i].unitRate);
					setSelectedPart(updateItemList[i].partName);
					if (updateItemList[i].gstRate === GST28) {
						setGSTRate28(true);
					}
					if (updateItemList[i].gstRate === GST18) {
						setGSTRate18(true);
					}
					if (updateItemList[i].gstRate === GST12) {
						setGSTRate12(true);
					}
					if (updateItemList[i].gstRate === GST5) {
						setGSTRate5(true);
					}
				}
			}
			setItemList([...updateItemList, partItemData]);
			// setItemList(updateItemList);

			form.setFieldsValue({
				totalInvoice: editData.totalInvoice,
			});
			for (let i = 0; i < updateItemList.length; i++) {
				if (
					updateItemList[i].partNumber &&
					(updateItemList[i].partNumber.number || updateItemList[i].partNumber.hsn)
				) {
					pid.push(updateItemList[i].partNumber.id);
				}
			}
			setPid(pid);
		}
		if (editData?.branch) {
			setBranch({ id: editData.branch.id, name: editData.branch.name });
		}
	}, [editData]);

	useEffect(() => {
		if (editData?.branch || editData?.id) return; // edit: keep loaded branch
		if (!nearestBranch?.id) return;
		setBranch({ id: nearestBranch.id, name: nearestBranch.name || "" });
	}, [nearestBranch, editData]);

	useEffect(() => {
		if (initialData && initialData.saleItemInvoice && Array.isArray(initialData.saleItemInvoice)) {
			const partDetails = {};
			for (const part of initialData.saleItemInvoice) {
				if (part && part.partNumber) {
					const partNumber = part.partNumber.partNumber;
					if (partNumber) {
						partDetails[partNumber] = parseInt(part.quantity || 0);
					}
				}
			}
			setInitialPartDetails(partDetails);
		}
	}, [initialData]);

	const onModify = () => {
		onEdit(false);
	};

	useEffect(() => {
		if (!editData) {
			platformApi.post("/api/idGenerate/salesSpares").then((res) => {
				let { data } = res;
				if (data.code === 200) {
					let { response } = data;
					setInvoiceNo(response.data);
				} else {
					// message.error("Couldn't fetch id");
				}
			});
		}
		platformApi.get("/api/sac/").then((res) => {
			if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
				setSAC(res.data.response.data);
			}
		});
	}, []);

	useEffect(() => {
		if (branch && branch.id) {
			platformApi.post("/api/sparesInventory/getAllByBranch", { branch: branch.id, skipNull: false }).then((res) => {
				const spareObject = {};
				if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
					for (const spare of res.data.response.data) {
						if (spare && spare.partNo) {
							const partNumber = spare.partNo.partNumber;
							spareObject[partNumber] = spare;
						}
					}
				}
				setSpareInventory(spareObject);
			});
		}
	}, [branch.id]);

	useEffect(() => {
		let newItemList = [...itemList];
		if (unitRate > 0 && quantity > 0) {
			if (newItemList.length > 0) {
				for (let i = 0; i < newItemList.length; i++) {
					if (parseInt(newItemList[i].quantity) > 0 && parseInt(newItemList[i].unitRate) > 0) {
						newItemList[i].rate = (parseFloat(newItemList[i].quantity) * parseFloat(newItemList[i].unitRate)).toFixed(2);
						newItemList[i].sgstAmount = parseFloat((newItemList[i].sgst / 100) * newItemList[i].rate).toFixed(2);
						newItemList[i].igstAmount = parseFloat((newItemList[i].igst / 100) * newItemList[i].rate).toFixed(2);
						newItemList[i].cgstAmount = parseFloat((newItemList[i].cgst / 100) * newItemList[i].rate).toFixed(2);
						sgstAmt = newItemList[i].sgstAmount;
						cgstAmt = newItemList[i].cgstAmount;
						igstAmt = newItemList[i].igstAmount;
					}
				}
			}
			setSGSTAmount(sgstAmt);
			setIGSTAmount(igstAmt);
			setCGSTAmount(cgstAmt);
			setItemList(newItemList);
			setquantity(undefined);
		}
	}, [unitRate, quantity]);

	useEffect(() => {
		let val = 0;
		let discountedPrice = 0;
		let newItemList = [...itemList];
		// Transaction level Dicount Calculation
		if (discountType === "At Transaction Level") {
			for (let i = 0; i < newItemList.length; i++) {
				let total = parseFloat(newItemList[i].unitRate * newItemList[i].quantity);
				if (total > 0) {
					grandTotal = (parseFloat(grandTotal) + parseFloat(total)).toFixed(2);
				}
			}
			if (discountLevel === "percent") {
				discountedPrice = (parseFloat(discountAmount) / 100) * grandTotal;
				val = val + discountedPrice;
				val = Math.round(val);
				setTotalDiscount(val || 0);
			} else if (discountLevel === "rupee") {
				val = val + parseFloat(discountAmount);
				setTotalDiscount(val || 0);
			}
		}
		// Item level Discount calculation
		if (discountType === "At Item Level") {
			for (let i = 0; i < newItemList.length; i++) {
				let total = newItemList[i].unitRate * newItemList[i].quantity;
				let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
				if (newItemList[i].discount > 0) {
					if (tax === "Tax Inclusive") {
						if (discountLevel === "percent") {
							discountedPrice = parseFloat(total / gstRateValue) * (parseFloat(newItemList[i].discount) / 100);
							val = val + discountedPrice;
							setTotalDiscount(val || 0);
						} else if (discountLevel === "rupee") {
							discountedPrice = parseFloat(total / gstRateValue) - newItemList[i].discount;
							val = val + parseFloat(newItemList[i].discount);
							setTotalDiscount(val || 0);
						}
					}
				}
			}
		}
		setItemList(newItemList);
	}, [discountLevel, discountAmount, discountType, discount, quantity, unitRate, rate, grandTtl]);

	useEffect(() => {
		//Calucate TAX at transaction level
		if (discountType === "At Transaction Level") {
			calculateTransactionTax();
		}
		//Calucate TAX at Item level
		if (discountType === "At Item Level") {
			calculateItemTax();
		}

		//calulate TCS
		if (TCS > 0) {
			let total = form.getFieldValue("totalInvoice");
			tcs = total * (TCS / 100);
			setConvertedTCS(tcs);
			total = parseFloat(total) + parseFloat(tcs);
			total = total.toFixed(2);
			setTotalInvoice(total);
			form.setFieldsValue({
				totalInvoice: total,
			});
		} else {
			setConvertedTCS(0);
		}
		//calculate adjustment
		if (adjustments > 0) {
			let total = form.getFieldValue("totalInvoice");
			totalAdjustments = (parseFloat(total) + parseFloat(adjustments)).toFixed(2);
			setTotalInvoice(totalAdjustments);
			form.setFieldsValue({
				totalInvoice: totalAdjustments,
			});
		}
		if (adjustments < 0) {
			let total = form.getFieldValue("totalInvoice");
			totalAdjustments = (parseFloat(total) - -parseFloat(adjustments)).toFixed(2);
			setTotalInvoice(totalAdjustments);
			form.setFieldsValue({
				totalInvoice: totalAdjustments,
			});
		}
	}, [
		unitRate,
		quantity,
		rate,
		tax,
		TCS,
		convertedTCS,
		totalInvoice,
		adjustments,
		discountAmount,
		discount,
		grandTtl,
		discountLevel,
		discountType,
		deleteItem,
	]);

	useEffect(() => {
		if (
			itemList &&
			itemList?.length > 0 &&
			(itemList[itemList?.length - 1].partNumber?.partNumber ||
				itemList[itemList?.length - 1].partNumber?.code ||
				itemList[itemList?.length - 1].quantity?.length > 0)
		) {
			handleAdd();
			setSearch("");
		}
		const selectItem = {};
		for (const item of itemList) {
			if (item.partNumber && item.partNumber.id) {
				selectItem[item.partNumber.id] = item.partNumber;
			}
		}
		setSelectItemObj(selectItem);
	}, [itemList]);

	const roundOf = (number) => {
		if (number == null) return number;
		const roundedNumber = parseFloat(number).toFixed(2);
		return parseFloat(roundedNumber);
	};

	const calculateTransactionTax = () => {
		let newItemList = [...itemList];
		let grandTotal = 0;
		let pCharge = 0;
		let labourCharge = 0;
		let consumableCharge = 0;
		let TotalCgst = 0;
		let TotalSgst = 0;
		let TotalIgst = 0;

		// First, calculate the pre-discount taxable base rate for each item
		// and sum them up to get the Sub Total
		let subTotal = 0;

		for (let i = 0; i < newItemList.length; i++) {
			const item = newItemList[i];
			if (
				((item.rate === undefined || item.rate === null) &&
					(!item.unitRate || !item.quantity)) ||
				!item.gstRate
			) {
				continue;
			}

			const rate =
				item.rate !== undefined && item.rate !== null
					? parseFloat(item.rate)
					: Number(item.unitRate) * Number(item.quantity);

			const gstRate = parseFloat(item.gstRate);
			const isService = item.partNumber?.code || item.jobCode;

			if (tax === "Tax Inclusive") {
				if (isService) {
					subTotal += rate;
				} else {
					subTotal += rate / (1 + gstRate / 100);
				}
			} else {
				subTotal += rate;
			}
		}

		// Apply Transaction-Level discount on Sub Total
		const discAmt = parseFloat(discountAmount) || 0;
		let totalDisc = 0;

		if (discAmt > 0 && !isNaN(discAmt)) {
			if (discountLevel === "percent") {
				totalDisc = parseFloat((subTotal * (discAmt / 100)).toFixed(2));
			} else {
				totalDisc = discAmt;
			}
		}

		const discountedTotal = Math.max(0, subTotal - totalDisc);

		// Re-distribute discount proportionally across items to get correct GST
		const discountRatio = subTotal > 0 ? discountedTotal / subTotal : 1;

		for (let i = 0; i < newItemList.length; i++) {
			const item = newItemList[i];

			// Skip if no rate or GST rate
			if (
				((item.rate === undefined || item.rate === null) &&
					(!item.unitRate || !item.quantity)) ||
				!item.gstRate
			) {
				item.grandTotal = Number(item.quantity || 0) * Number(item.unitRate || 0);
				grandTotal += item.grandTotal;
				continue;
			}

			const rate =
				item.rate !== undefined && item.rate !== null
					? parseFloat(item.rate)
					: Number(item.unitRate) * Number(item.quantity);

			const gstRate = parseFloat(item.gstRate);
			const isService = item.partNumber?.code || item.jobCode;

			let baseAmount = rate;
			if (tax === "Tax Inclusive") {
				if (isService) {
					baseAmount = rate;
				} else {
					baseAmount = rate / (1 + gstRate / 100);
				}
			} else {
				baseAmount = rate;
			}

			// Apply proportional discount to baseAmount
			const discountedBase = baseAmount * discountRatio;
			const gstAmount = discountedBase * (gstRate / 100);
			const itemTotal = discountedBase + gstAmount;

			// Calculate CGST/SGST/IGST splits safely
			const igst = Number(item.igst) || 0;
			const sgst = Number(item.sgst) || 0;
			const cgst = Number(item.cgst) || 0;
			const safeGstRate = gstRate === 0 ? 1 : gstRate;

			item.igstAmount = roundOf((igst / safeGstRate) * gstAmount);
			item.sgstAmount = roundOf((sgst / safeGstRate) * gstAmount);
			item.cgstAmount = roundOf((cgst / safeGstRate) * gstAmount);
			item.grandTotal = itemTotal;

			// Accumulate totals
			grandTotal += itemTotal;
			TotalCgst += item.cgstAmount;
			TotalSgst += item.sgstAmount;
			TotalIgst += item.igstAmount;

			// Categorize charges
			if (item.rate) {
				if (item.partNumber.code || item.jobCode) {
					labourCharge = parseFloat(labourCharge) + parseFloat(item.rate);
					if (item.partNumber?.consumable || item.jobCode?.consumable) {
						consumableCharge = parseFloat(consumableCharge) + parseFloat(item.rate);
					}
				} else if (item.partNumber.hsn) {
					pCharge = parseFloat(pCharge) + parseFloat(item.rate);
				}
			}
		}

		// Standard roundoff calculation
		let rounded = Math.round(grandTotal);
		let roundoffValue = (rounded - grandTotal).toFixed(2);

		grandTotal = parseFloat(grandTotal).toFixed(0);
		setGrandTotal(grandTotal);
		setTotalInvoice(grandTotal);
		setSGSTAmount(TotalSgst);
		setIGSTAmount(TotalIgst);
		setCGSTAmount(TotalCgst);
		setTotalDiscount(roundOf(totalDisc));
		setItemList(newItemList);

		form.setFieldsValue({
			grantTotal: grandTotal,
			totalInvoice: grandTotal,
			partCharge: pCharge,
			labourCharge: labourCharge,
			consumableCharge: consumableCharge,
			cgst: roundOf(TotalCgst),
			sgst: roundOf(TotalSgst),
			igst: roundOf(TotalIgst),
			roundoff: roundoffValue,
		});
	};

	const calculateItemTax = () => {
		let newItemList = [...itemList];
		let grandTotal = 0;
		let pCharge = 0;
		let labourCharge = 0;
		let consumableCharge = 0;
		let TotalCgst = 0;
		let TotalSgst = 0;
		let TotalIgst = 0;
		let totalDiscItem = 0;

		for (const index in newItemList) {
			const item = newItemList[index];

			// Skip if no rate or GST rate
			if (
				((item.rate === undefined || item.rate === null) &&
					(!item.unitRate || !item.quantity)) ||
				!item.gstRate
			) {
				item.grandTotal = Number(item.quantity || 0) * Number(item.unitRate || 0);
				grandTotal += item.grandTotal;
				continue;
			}

			let rate =
				item.rate !== undefined && item.rate !== null
					? parseFloat(item.rate)
					: Number(item.unitRate) * Number(item.quantity);
			let gstRate = parseFloat(item.gstRate);
			let gstRateValue = gstRate / 100 + 1;
			let discountVal = parseFloat(item.discount) || 0;
			let total = rate;
			let gstAmount = 0;

			// Determine if item is service (SAC) or product (HSN)
			const isService = item.partNumber?.code || item.jobCode;

			if (tax === "Tax Inclusive") {
				if (isService) {
					// For service items under Tax Inclusive, rate is exclusive
					let baseAmount = rate;
					if (discountVal > 0) {
						if (discountLevel === "percent") {
							baseAmount = baseAmount - baseAmount * (discountVal / 100);
						} else {
							baseAmount = baseAmount - discountVal;
						}
					}
					gstAmount = baseAmount * (gstRate / 100);
					total = baseAmount + gstAmount;
				} else {
					// For product items, rate is inclusive
					let baseAmount = rate / gstRateValue;
					if (discountVal > 0) {
						if (discountLevel === "percent") {
							baseAmount = baseAmount - baseAmount * (discountVal / 100);
						} else {
							let discountedTotal = rate - discountVal;
							baseAmount = discountedTotal / gstRateValue;
						}
					}
					gstAmount = baseAmount * (gstRate / 100);
					total = baseAmount + gstAmount;
				}
			} else {
				// Tax Exclusive
				let baseAmount = rate;
				if (discountVal > 0) {
					if (discountLevel === "percent") {
						baseAmount = baseAmount - baseAmount * (discountVal / 100);
					} else {
						baseAmount = baseAmount - discountVal;
					}
				}
				gstAmount = baseAmount * (gstRate / 100);
				total = baseAmount + gstAmount;
			}

			// Calculate CGST/SGST/IGST splits safely
			const igst = Number(item.igst) || 0;
			const sgst = Number(item.sgst) || 0;
			const cgst = Number(item.cgst) || 0;
			const safeGstRate = gstRate === 0 ? 1 : gstRate;

			item.igstAmount = roundOf((igst / safeGstRate) * gstAmount);
			item.sgstAmount = roundOf((sgst / safeGstRate) * gstAmount);
			item.cgstAmount = roundOf((cgst / safeGstRate) * gstAmount);
			item.grandTotal = total;

			// Accumulate totals
			grandTotal += total;
			TotalCgst += item.cgstAmount;
			TotalSgst += item.sgstAmount;
			TotalIgst += item.igstAmount;
			// Accumulate item-level discount amount
			if (discountVal > 0) {
				if (discountLevel === "percent") {
					totalDiscItem += rate * (discountVal / 100);
				} else {
					totalDiscItem += discountVal;
				}
			}

			// Categorize charges
			if (item.rate) {
				if (item.partNumber.code || item.jobCode) {
					labourCharge = parseFloat(labourCharge) + parseFloat(item.rate);
					if (item.partNumber?.consumable || item.jobCode?.consumable) {
						consumableCharge = parseFloat(consumableCharge) + parseFloat(item.rate);
					}
				} else if (item.partNumber.hsn) {
					pCharge = parseFloat(pCharge) + parseFloat(item.rate);
				}
			}
		}

		// Standard roundoff calculation
		let rounded = Math.round(grandTotal);
		let roundoffValue = (rounded - grandTotal).toFixed(2);

		grandTotal = parseFloat(grandTotal).toFixed(0);
		setGrandTotal(grandTotal);
		setTotalInvoice(grandTotal);
		setSGSTAmount(TotalSgst);
		setIGSTAmount(TotalIgst);
		setCGSTAmount(TotalCgst);
		setTotalDiscount(roundOf(totalDiscItem));
		setItemList(newItemList);

		form.setFieldsValue({
			grantTotal: grandTotal,
			totalInvoice: grandTotal,
			partCharge: pCharge,
			labourCharge: labourCharge,
			consumableCharge: consumableCharge,
			cgst: roundOf(TotalCgst),
			sgst: roundOf(TotalSgst),
			igst: roundOf(TotalIgst),
			roundoff: roundoffValue,
		});
	};

	const searchPartsAndJobCodes = async (searchString) => {
		try {
			const [partsResponse, jobCodesResponse] = await Promise.all([
				platformApi.post("/api/options/get/", {
					module: "sparesInventories",
					column: "partNumber",
					searchString: searchString,
					searchColumns: ["partNumber", "partName"],
					size: 10,
					page: 1,
					except: null,
					branch: branch.id || undefined,
				}),
				platformApi.post("/api/options/get/", {
					module: "jobCodes",
					column: "code",
					searchString: searchString,
					searchColumns: ["code", "description"],
					size: 10,
					page: 1,
					except: null,
				})
			]);

			const parts = partsResponse.data.response || [];
			const jobs = jobCodesResponse.data.response || [];

			setPartsData((parts || []).map(p => p.partNo).filter(p => p != null));
			setJobCode(jobs || []);
		} catch (error) {
			console.error('Error searching parts and job codes:', error);
		}
	};

	const validateQuantity = (event) => {
		if (event.target.value === "") return;
		const positiveNumber = /^[1-9]\d*$/;
		if (!positiveNumber.test(event.target.value)) {
			event.target.value = 1;
		}
	};

	const getMaxQty = (partNumber, record) => {
		if (!partNumber || partNumber.includes("OCPART") || partNumber.includes("OCLABOUR")) return null;

		const isPaid = editData && (editData.status === "PAID" || editData.status === "FEEDBACK_COMPLETED");
		const currentQty = parseInt(record?.quantity || 0);

		if (isPaid) {
			// Use the DB-persisted maxAccQty snapshot: the AccQty captured at the
			// exact moment this invoice was paid. It is permanently frozen and will
			// never change even if spare inventory is updated afterwards.
			if (record.maxAccQty != null) return Math.max(currentQty, record.maxAccQty);
			// Fallback for old invoices that pre-date this feature (maxAccQty not set)
			return currentQty;
		}

		// Pending / new invoice: dynamic — follow live inventory so the user sees
		// the actual available stock in real time.
		const inventory = spareInventory[partNumber];
		if (!inventory) return 0;

		const isCounterSale = invoiceType === "counterSale";
		const availableQty = parseInt(isCounterSale ? (inventory.phyQuantity || 0) : (inventory.accQuantity || 0));
		const baseAvailable = Math.max(0, availableQty);

		return Math.max(currentQty, baseAvailable);
	};

	const renderColumns = () => {
		const columns = [
			{
				title: "Part Details",
				dataIndex: "partNumber",
				key: "partNumber",
				width: 360,
				render: (record, data, key) => (
					<Form.Item>
						<Select
							dropdownStyle={{
								overflowY: "auto",
								overflowX: "hidden",
							}}
							onChange={(event) => {
								handlePartDetail(event, data);
							}}
							onSearch={async (event) => {
								if (event) {
									if (event.includes("oclabour") || event.includes("OCLABOUR") || event.includes("ocLabour")) {
										const newItemList = [...itemList];
										if (event !== undefined) {
											const pName = event.split("-")[1];
											for (let item of newItemList) {
												if (item.id === data.id) {
													let part = {
														id: item.id,
														code: `OCLABOUR-${pName}`,
														sac: SAC[0],
														partName: `OCLABOUR-${pName}`,
													};
													item.partNumber = part;
													item.hsn = part.sac || null;
													item.cgst = part.sac ? part.sac.cgst : 0;
													item.igst = part.sac ? part.sac.igst : 0;
													item.sgst = part.sac ? part.sac.sgst : 0;
													item.gstRate = part.sac ? (Number(part.sac.cgst || 0) + Number(part.sac.sgst || 0)) : 0;
													let price = part?.vehicleModel?.filter((item) => item.vehicle.id === model);
													item.unitRate = price?.length ? price[0].price : 0;
													item.quantity = 1;
													setquantity(1);
													setUnitRate(price?.length ? price[0].price : 0);
													if (item.gstRate === GST18) {
														setGSTRate18(true);
													}
													if (item.gstRate === GST28) {
														setGSTRate28(true);
													}
													if (item.gstRate === GST12) {
														setGSTRate12(true);
													}
													if (item.gstRate === GST5) {
														setGSTRate5(true);
													}
													setCGST(part.sac.cgst), setSGST(part.sac.sgst), setIGST(part.sac.igst);
												}
											}
										}
										setItemList(newItemList);
										getJobCodes();
									} else {
										// Debounce the search - wait 300ms after user stops typing
										if (searchTimeoutRef.current) {
											clearTimeout(searchTimeoutRef.current);
										}

										setSearching(true);

										searchTimeoutRef.current = setTimeout(async () => {
											// Use the combined search function to prevent race conditions
											await searchPartsAndJobCodes(event);
											setSearching(false);
										}, 300); // 300ms debounce delay
									}
								}
								handleInventory(data.quantity, data.partNumber?.partNumber);
							}}
							value={(() => {
								if (data?.partNumber && typeof data.partNumber === "object") {
									if (data.partNumber.code) {
										return data.partNumber.description
											? `${data.partNumber.code} - ${data.partNumber.description}`
											: data.partNumber.code;
									}
									if (data.partNumber.partNumber) {
										return `${data.partNumber.partNumber} - ${data.partNumber.partName || ""}`;
									}
								} else if (data?.partNumber && typeof data.partNumber === "string" && data.partNumber !== "[object Object]") {
									return data.partNumber;
								}
								if (data?.jobCode?.code) {
									return data.jobCode.description
										? `${data.jobCode.code} - ${data.jobCode.description}`
										: data.jobCode.code;
								}
								if (data?.code) {
									return data.code;
								}
								return "Part Number";
							})()}
							disabled={editable}
							showSearch
							showAction={["click", "focus"]}
							placeholder="Part Number/Job Code"
							filterOption={(input, option) => {
								if (!input) return true;
								const children = option.props.children;
								const text = Array.isArray(children) ? children.join('') : String(children || '');
								return text.toLowerCase().includes(input.toLowerCase());
							}}
							loading={searching}
							notFoundContent={searching ? "Searching..." : "No results found"}
							onSelect={(event) => {
								handlePartDetail(event, data);
							}}
						>
							{dataTemp.length &&
								dataTemp.map((part) => {
									if (part.id in selectItemObj && part.id !== data.partNumber?.id) return null;
									return (
										<Select.Option key={part.id} value={part.value || part.code || part.partNumber}>
											{part.label}
										</Select.Option>
									);
								})}
						</Select>
					</Form.Item>
				),
			},
			{
				title: "HSN",
				dataIndex: "hsn",
				key: "hsn",
				width: 80,
				render: (record, index) => (
					<Form.Item>
						<span>{record && record.code}</span>
					</Form.Item>
				),
			},
			{
				title: "GST%",
				dataIndex: "gstRate",
				key: "gstRate",
				width: 70,
				render: (data, record) => (
					<Form.Item>
						<span>{record && record.gstRate}</span>
					</Form.Item>
				),
			},
			{
				title: "Quantity",
				dataIndex: "quantity",
				key: "quantity",
				width: 95, // +10% vs 80 so Qty /stock displays clearly
				render: (data, record, index) => {
					const partNumber = record.partNumber?.partNumber;
					const maxQtyHint = getMaxQty(partNumber, record);
					return (
						<Form.Item
							validateStatus={`${quantityValidation[partNumber] ? "error" : "success"}`}
							help={quantityValidation[partNumber]}
						>
							<Input
								key="quantity"
								disabled={editable}
								onChange={(event) => {
									const value = event.target.value.replace(/[^0-9]/g, "");
									handlequantity({ target: { value } }, record);
								}}
								ref={(el) => (partsRef[index] = el)}
								placeholder="Qty"
								value={record && record.quantity}
								addonAfter={
									maxQtyHint != null
										? <span style={{ color: '#888', fontSize: 12 }}>/{maxQtyHint}</span>
										: null
								}
							/>
						</Form.Item>
					);
				},
			},
			{
				title: "Unit rate",
				dataIndex: "unitRate",
				key: "unitRate",
				width: 100,
				render: (data, record, index) => (
					<Form.Item>
						<Input
							key="unitRate"
							disabled={editable}
							onChange={(event) => {
								handleUnitrate(event, record);
							}}
							placeholder="Unit Rate"
							value={record && record.unitRate}
						/>
					</Form.Item>
				),
			},
			{
				title: "Discount",
				dataIndex: "discount",
				key: "discount",
				width: 80,
				render: (data, record) => (
					<Form.Item>
						<Input
							key="discount"
							onChange={(event) => {
								handleDiscount(event, record);
							}}
							disabled={editable}
							placeholder="Discount"
							value={record && record.discount}
						/>
					</Form.Item>
				),
			},
			{
				title: "Gross Amount",
				dataIndex: "rate",
				key: "rate",
				width: 120,
				render: (data, record) => (
					<Form.Item>
						<Input key="rate" disabled={editable} placeholder="Rate" value={record && record.rate} />
					</Form.Item>
				),
			},
			{
				title: "Bin Location",
				dataIndex: "binLocation",
				key: "binLocation",
				width: 120,
				render: (data, record) => {
					const partNumber = record.partNumber?.partNumber;
					const binLocation = partNumber && spareInventory[partNumber]
						? spareInventory[partNumber].binNum
						: '-';

					return (
						<Form.Item>
							<Input
								key="binLocation"
								disabled={true}
								placeholder="Bin Location"
								value={binLocation}
							/>
						</Form.Item>
					);
				},
			},
			{
				title: "Action",
				dataIndex: "remove",
				key: "x",
				width: 80,
				render: (data, record) => (
					<Form.Item>
						{!editable && (
							itemList.length > 1 ? (
								<Popconfirm
									title="Sure to delete?"
									onConfirm={() => {
										handleDelete(record.id);
									}}
								>
									<a style={{ color: "#6c7b8a" }}>Delete</a>
								</Popconfirm>
							) : (
								<a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
							)
						)}
					</Form.Item>
				),
			},
		];

		return columns.filter((col) => (discountType === "At Transaction Level" ? col.dataIndex !== "discount" : col));
	};



	const validateInventory = (itemList) => {
		for (const item of itemList) {
			if (item.partNumber?.partNumber) {
				const partNumber = item.partNumber.partNumber;
				if (handleInventory(item.quantity, partNumber, item) === false) return false;
			}
		}
		return true;
	};

	const handleSubmit = async () => {
		setFormSubmit(true);
		const isValid = validateInventory(itemList);
		if (!isValid) return message.error("Stock Not available in Inventory");
		form.validateFields((validationError) => {
			if (validationError !== null) {
				return;
			}

			let totalSGSTAmt = 0;
			let totalCGSTAmt = 0;
			let totalIGSTAmt = 0;
			let newItemList = [...itemList];
			const customerStateCode = stateName ? String(stateName).slice(0, 2) : "";
			const branchStateCode = gst ? String(gst).slice(0, 2) : "";
			const isInterState =
				Boolean(customerStateCode) &&
				Boolean(branchStateCode) &&
				customerStateCode !== branchStateCode;

			for (let i = 0; i < newItemList.length; i++) {
				const sgstAmtVal = parseFloat(newItemList[i].sgstAmount) || 0;
				const cgstAmtVal = parseFloat(newItemList[i].cgstAmount) || 0;
				let igstAmtVal = parseFloat(newItemList[i].igstAmount) || 0;

				if (isInterState && igstAmtVal <= 0 && cgstAmtVal + sgstAmtVal > 0) {
					igstAmtVal = cgstAmtVal + sgstAmtVal;
					newItemList[i].igstAmount = igstAmtVal.toFixed(2);
				}
				if (isInterState) {
					newItemList[i].cgstAmount = null;
					newItemList[i].sgstAmount = null;
				} else {
					newItemList[i].igstAmount = null;
				}

				if (sgstAmtVal > 0) totalSGSTAmt += sgstAmtVal;
				if (cgstAmtVal > 0) totalCGSTAmt += cgstAmtVal;
				if (igstAmtVal > 0) totalIGSTAmt += igstAmtVal;

				newItemList[i].discountPercent = discountLevel === "percent" ? newItemList[i].discount : 0;
				newItemList[i].discountRate = discountLevel === "rupee" ? newItemList[i].discount : 0;
			}

			const filteredList = newItemList.filter((item) => {
				if (!item || !item.partNumber || !item.quantity || !item.rate) return false;
				const isJobCode = Boolean(item.partNumber.code);
				const isPart = Boolean(item.partNumber.partNumber);
				return isJobCode || isPart;
			});

			if (filteredList.length === 0) {
				message.error("Please add at least one part or labor item before submitting.");
				return;
			}

			const totalAmt = parseFloat(form.getFieldValue("totalInvoice") || totalInvoice || 0);
			if (isNaN(totalAmt) || totalAmt <= 0) {
				message.error("Total amount must be greater than zero.");
				return;
			}

			newItemList = filteredList;
			setItemList(newItemList);
			const data = {
				partsCharge: form.getFieldValue("partCharge"),
				labourCharge: form.getFieldValue("labourCharge"),
				consumableCharge: form.getFieldValue("consumableCharge"),
				invoiceNumber: invoiceNo,
				invoiceDate: invoiceDate ? moment(invoiceDate) : moment(),
				invoiceType,
				jobOrder: form.getFieldValue("JobNo"),
				partyName:
					newCustomer != null ? newCustomer : modifyType ? editData && editData.partyName && editData.partyName.id : customerID,
				itemrate: tax,
				discountType,
				discountPercent: discountLevel === "percent" ? discountAmount : 0,
				discountRate: discountLevel === "rupee" ? discountAmount : 0,
				cgst: isInterState ? null : totalCGSTAmt,
				sgst: isInterState ? null : totalSGSTAmt,
				igst: isInterState
					? totalIGSTAmt || totalCGSTAmt + totalSGSTAmt
					: null,
				tcs: TCS,
				totalDiscount,
				totalInvoice: form.getFieldValue("totalInvoice") ? form.getFieldValue("totalInvoice") : totalInvoice,
				adjustments,
				saleItemInvoice: newItemList,
				branch: branch.id,
				deleteData: deleteData,
				deletePartData: deletePartData,
			};

			setBtnFlag(true);
			if (editData && editData?.id) {
				platformApi
					.put(`/api/saleSpareInvoice/${id}`, data)
					.then((result) => {
						let { data } = result;
						if (data.code === 200) {
							let { response } = data;
							if (response.code === 200) {
								message.success("SSI Modified Successfully");
							} else {
								message.error("Unable to Modify SSI");
							}
							history.push("/autoadmin/counter_sale");
						}
					})
					.catch((err) => {
						console.error("SSI Add Error: ", err);
						message.error("Couldn't update SSI");
					});
			} else {
				platformApi
					.post("/api/saleSpareInvoice/", data)
					.then((result) => {
						let { data } = result;
						if (data.code === 200) {
							let { response } = data;
							if (response.code === 200) {
								message.success("SSI Added Successfully");
							} else {
								message.error("Unable to Add SSI");
							}
							history.push("/autoadmin/counter_sale");
						}
					})
					.catch((err) => {
						message.error("Couldn't Add SSI");
					});
			}
		});
	};

	const handleCancel = () => {
		form.resetFields();
		setInvoiceDate(null);
		// Setflag(false);
		setInvoiceNumber("");
		setCustomer("");
		setGrandTotal(0);
		setAdjustments(0);
		setTCS(0);
		setDiscountAmount(0);
		setSelectedPart("");
		//set//stateName("");
		setGst("");
		setDeletePartData([]);
		setItemList([partItemData]);
		history.push("/autoadmin/counter_sale");
	};

	const handleAdd = () => {
		let newArr = [...itemList, partItemData];
		setItemList(newArr);
	};

	const handleDelete = (selectedId) => {
		if (itemList.length === 1) {
			return;
		}
		let grandTotal = 0;
		const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
		for (let i = 0; i < updatedDataSource.length; i++) {
			grandTotal = (parseFloat(grandTotal) + parseFloat(updatedDataSource[i].grandTotal)).toFixed(2);
			setGrandTotal(grandTotal);
			setTotalInvoice(grandTotal);
			form.setFieldsValue({
				grantTotal: grandTotal,
				totalInvoice: grandTotal,
			});
		}
		setItemList(updatedDataSource);
		deleteParts(selectedId);
	};
	const deleteParts = (e) => {
		const deleteSource = itemList.filter((item) => item.id == e);
		if (pid.indexOf(e) >= 0) {
			deleteData.push(e);
		}
		setDeleteData(deleteData);

		for (let i = 0; i < deleteSource.length; i++) {
			if (deleteSource[i].partNumber.number || deleteSource[i].partNumber.hsn) {
				deletePartData.push(deleteSource[i]);
			}
		}
		setDeletePartData(deletePartData);
	};
	const handleInvoiceDate = (e) => {
		if (e) {
			const date = new Date(e._d);
			setInvoiceDate(moment(date));
		}
	};

	const handleCustomerChange = (customerID) => {
		setCustomer(customerID);
		setNewCustomer(customerID);
		for (let item of customer) {
			if (item.id === customerID) {
				setSelectedCustomer(item);
				break;
			}
		}
		customer.map((item) => {
			if (item.id === customerID) {
				if (!item.name) {
					setTemp(true);
				}
			}
		});
	};
	const handlePartDetail = (event, data) => {
		const newItemList = [...itemList];
		setSelectedPart(event);
		if (event !== undefined) {
			partsData.map((part) => {
				if (part.partNumber === event) {
					setSelectPart(part);
					for (let item of newItemList) {
						if (item.id === data.id) {
							item.partNumber = part;
							item.hsn = part.hsn || null;
							item.cgst = part.hsn ? part.hsn.cgst : 0;
							item.igst = part.hsn ? part.hsn.igst : 0;
							item.sgst = part.hsn ? part.hsn.sgst : 0;
							item.gstRate = part.hsn ? (Number(part.hsn.cgst || 0) + Number(part.hsn.sgst || 0)) : 0;
							item.unitRate = part.mrp;
							item.quantity = 1;
							setquantity(1);
							setUnitRate(part.mrp);
							if (item.gstRate === GST18) {
								setGSTRate18(true);
							}
							if (item.gstRate === GST28) {
								setGSTRate28(true);
							}
							if (item.gstRate === GST12) {
								setGSTRate12(true);
							}
							if (item.gstRate === GST5) {
								setGSTRate5(true);
							}
							setCGST(part.hsn ? part.hsn.cgst : 0);
							setSGST(part.hsn ? part.hsn.sgst : 0);
							setIGST(part.hsn ? part.hsn.igst : 0);
						}
					}
				}
			});

			jobCode.map((part) => {
				if (part.code === event) {
					for (let item of newItemList) {
						if (item.id === data.id) {
							item.partNumber = part;
							item.hsn = part.sac || null;
							item.cgst = part.sac ? part.sac.cgst : 0;
							item.igst = part.sac ? part.sac.igst : 0;
							item.sgst = part.sac ? part.sac.sgst : 0;
							item.gstRate = part.sac ? (Number(part.sac.cgst || 0) + Number(part.sac.sgst || 0)) : 0;
							let price = part.vehicleModel.filter((item) => item.vehicle.id === model);
							item.unitRate = price.length && price[0].price;
							item.quantity = 1;
							setquantity(1);
							setUnitRate(price.length && price[0].price);
							if (item.gstRate === GST18) {
								setGSTRate18(true);
							}
							if (item.gstRate === GST28) {
								setGSTRate28(true);
							}
							if (item.gstRate === GST12) {
								setGSTRate12(true);
							}
							if (item.gstRate === GST5) {
								setGSTRate5(true);
							}
							setCGST(part.sac ? part.sac.cgst : 0);
							setSGST(part.sac ? part.sac.sgst : 0);
							setIGST(part.sac ? part.sac.igst : 0);
						}
					}
				}
			});
		}
		setItemList(newItemList);
		getPartsDetails();
		getJobCodes();
	};
	const getJobCodes = () => {
		platformApi
			.get("/api/jobCode/")
			.then((res) => {
				const { data } = res;
				if (data.code === 200) {
					setJobCode(data.response.data);
				}
			})
			.catch((err) => {
				console.error("JobCode Fetch Error: ", err);
				message.error("Couldn't Fetch JobCodes");
			});
	};
	const getPartsDetails = () => {
		platformApi
			.post(`/api/sparesInventory/branch/get/`, {
				page: 1,
				size: 100,
				searchString: "",
			})
			.then((res) => {
				const { data } = res;
				if (data.code === 200) {
					const { response } = data;
					if (response.code === 200) {
						let parts = [];
						for (let item of response.data) {
							let unitRate = 0;
							item.transactions &&
								item.transactions.sparesPurchase.map((item2) => {
									item2.purchaseItemInvoice.map((item3) => {
										if (item.partNo.id === item3.partNumber.id) {
											unitRate += item3.unitRate;
										}
									});
								});
							item.partNo.unitRate = unitRate;
							parts.push(item.partNo);
						}
						setPartsData(parts);
					}
				} else {
					message.error("Unable to fetch Parts", 2);
				}
			})
			.catch((error) => {
				console.error("Error on Parts Master : ", error);
				message.error("Unable to fetch Parts", 2);
			});
	};

	const handleInventory = (quantity, partNumber, record) => {
		if (
			quantity === "" ||
			partNumber == null ||
			partNumber.includes("OCPART") ||
			partNumber.includes("OCLABOUR")
		)
			return;
		setQuantityValidation((prev) => ({ ...prev, [partNumber]: false }));
		const maxQty = getMaxQty(partNumber, record);
		if (Number(quantity) > maxQty) {
			setQuantityValidation((prev) => ({
				...prev,
				[partNumber]: `Max Qty Available: ${maxQty}`,
			}));
			return false;
		}
		return true;
	};

	const handlequantity = (event, record) => {
		const partNumber = record.partNumber?.partNumber;
		let value = event.target.value;

		if (partNumber && !partNumber.includes("OCPART") && !partNumber.includes("OCLABOUR")) {
			const maxQty = getMaxQty(partNumber, record);
			if (Number(value) > maxQty) {
				value = String(maxQty);
				message.warning(`Maximum quantity available for this part is ${maxQty}`, 2);
			}
		}

		setquantity(value);
		let newItemList = [...itemList];
		for (let item of newItemList) {
			if (item.id === record.id) {
				item.quantity = value;
				item.rate = parseFloat(value || 0) * parseFloat(item.unitRate || 0);
				break;
			}
		}
		setItemList(newItemList);
		handleInventory(value, partNumber, record);
	};
	const handleDiscount = (event, record) => {
		setDiscount(event.target.value);
		let newItemList = [...itemList];
		for (let item of newItemList) {
			if (item.id === record.id) {
				item.discount = event.target.value;
				break;
			}
		}
	};

	const handleUnitrate = (event, record) => {
		// Only allow numeric values and decimal point
		const value = event.target.value;
		const numericValue = value.replace(/[^0-9.]/g, '');

		// Prevent multiple decimal points
		const decimalCount = (numericValue.match(/\./g) || []).length;
		const finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

		setUnitRate(finalValue);
		let newItemList = [...itemList];
		for (let item of newItemList) {
			if (item.id === record.id) {
				item.unitRate = finalValue;
				item.rate = item.quantity * finalValue;
				break;
			}
		}
	};

	const handleDiscountAmount = (event) => {
		// Only allow numeric values and decimal point
		const value = event.target.value;
		const numericValue = value.replace(/[^0-9.]/g, '');

		// Prevent multiple decimal points
		const decimalCount = (numericValue.match(/\./g) || []).length;
		const finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

		setDiscountAmount(finalValue);
	};

	const handleTCS = (event) => {
		// Only allow numeric values and decimal point
		const value = event.target.value;
		const numericValue = value.replace(/[^0-9.]/g, '');

		// Prevent multiple decimal points
		const decimalCount = (numericValue.match(/\./g) || []).length;
		const finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

		setTCS(finalValue);
	};

	const handleAdjustments = (event) => {
		// Only allow numeric values and decimal point
		const value = event.target.value;
		const numericValue = value.replace(/[^0-9.-]/g, '');

		// Prevent multiple decimal points and multiple minus signs
		const decimalCount = (numericValue.match(/\./g) || []).length;
		const minusCount = (numericValue.match(/-/g) || []).length;

		let finalValue = numericValue;
		if (decimalCount > 1) {
			finalValue = finalValue.slice(0, finalValue.lastIndexOf('.'));
		}
		if (minusCount > 1) {
			finalValue = finalValue.replace(/-/g, '');
			finalValue = '-' + finalValue;
		}

		// Ensure minus sign is only at the beginning
		if (finalValue.includes('-') && finalValue.indexOf('-') !== 0) {
			finalValue = finalValue.replace(/-/g, '');
		}

		setAdjustments(finalValue);
	};

	const handleGrandTotal = (event) => {
		// Only allow numeric values and decimal point
		let value = event.target.value;
		value = value.replace(/[^0-9.]/g, '');

		// Prevent multiple decimal points
		const decimalCount = (value.match(/\./g) || []).length;
		if (decimalCount > 1) {
			value = value.slice(0, value.lastIndexOf('.'));
		}

		if (event.target.value !== value) {
			event.target.value = value;
		}
		setGrandTotal(value);
		setFieldsValue({ grantTotal: value });
	};

	const handleTotalInvoice = (event) => {
		// Only allow numeric values and decimal point
		let value = event.target.value;
		value = value.replace(/[^0-9.]/g, '');

		// Prevent multiple decimal points
		const decimalCount = (value.match(/\./g) || []).length;
		if (decimalCount > 1) {
			value = value.slice(0, value.lastIndexOf('.'));
		}

		if (event.target.value !== value) {
			event.target.value = value;
		}
		setTotalInvoice(value);
		setFieldsValue({ totalInvoice: value });
	};

	const validateEmptyField = (value) => {
		if (value === "" || value === undefined) {
			return false;
		}
		return true;
	};

	const getNumbers = (search) => {
		if (search.searchString && !/^\d+$/.test(search.searchString.trim())) {
			search.setValue([]);
			return;
		}
		platformApi
			.post("/api/options/get/", {
				module: search.module,
				column: search.column,
				searchString: search.searchString,
				fields: search.fields,
				size: 100,
				page: 1,
				except: null,
			})
			.then((res) => {
				if (res.data.response) {
					search.setValue(res.data.response);
				} else {
					search.setValue([]);
				}
			});
	};

	const searchJobNo = (search) => {
		let temp = [];
		platformApi
			.post("/api/options/get/", {
				module: search.module,
				column: search.column,
				searchString: search.searchString,
				fields: search.fields,
				size: 100,
				page: 1,
				except: null,
			})
			.then((res) => {
				temp = res.data.response.filter((item) => {
					return item.jobStatus != "Invoice" || item.jobStatus != "Payment Received" || item.jobStatus != "Gate Pass";
				});
				search.setValue(temp);
			});
	};

	const getJobOrder = (value) => {
		setFieldsValue({
			JobNo: value,
		});
		let grandTotal = 0;
		let TotalCgst = 0;
		let TotalSgst = 0;
		let TotalIgst = 0;
		let pCharge = 0;
		let labourCharge = 0;
		let consumableCharge = 0;
		let estTotal = 0;
		let temp = 0;
		platformApi
			.get("/api/materialIssue/jobMaterial/" + value)
			.then((resp) => {
				let { data } = resp;
				if (data.code === 200) {
					let { response } = data;
					if (response.code === 200) {
						if (response.data) {
							let partItemList = [];
							if (response.data.length && response.data[0].parts) {
								for (let i = 0; i < response.data.length; i++) {
									const element = response.data[i];
									partItemList.push(...element.parts);
								}
							} else {
								message.info("No Materials in this JobOrder");
							}
							for (let i = 0; i < partItemList.length; i++) {
								const item = { ...partItemList[i].part };
								if (!dataTemp.some((tempItem) => item.partNumber === tempItem.value)) {
									platformApi.get("/api/partsMaster/" + item.id).then((res) => {
										let { data } = res;
										if (data.code === 200) {
											let { response } = data;
											if (response.code === 200) {
												const temp = {
													label: `${response.data.partNumber} - ${response.data.partName}`,
													value: response.data.partNumber,
													id: response.data.id,
												};
												setDataTemp([...dataTemp, temp]);
											}
										}
									});
								}

								partItemList[i].partNumber = item;
								partItemList[i].partNumber.partName = partItemList[i].partName;
								partItemList[i].hsn = item.hsn;
								partItemList[i].cgst = item.hsn && item.hsn.cgst;
								partItemList[i].sgst = item.hsn && item.hsn.sgst;
								partItemList[i].igst = item.hsn && item.hsn.igst;
								partItemList[i].gstRate = item.hsn && item.hsn.igst;
								// partItemList[i].quantity = partItemList[i].quantity;
								partItemList[i].unitRate = partItemList[i].mrp;
								partItemList[i].rate = partItemList[i].quantity * partItemList[i].unitRate;
								partItemList[i].sgstAmount = parseFloat((partItemList[i].sgst / 100) * partItemList[i].rate).toFixed(2);
								partItemList[i].igstAmount = parseFloat((partItemList[i].igst / 100) * partItemList[i].rate).toFixed(2);
								partItemList[i].cgstAmount = parseFloat((partItemList[i].cgst / 100) * partItemList[i].rate).toFixed(2);

								setSelectedPart(item.partNumber);

								let total = parseFloat(partItemList[i].rate);
								// let finTotal = parseFloat(partItemList[i].rate)
								// let gstRateValue = (partItemList[i].gstRate / 100) + parseInt(1);
								// taxExlusive = (total * (partItemList[i].gstRate / 100)).toFixed(2);
								// total = (parseFloat(total) + parseFloat(taxExlusive)).toFixed(2);
								// partItemList[i].grandTotal = finTotal

								partItemList[i].grandTotal = total;
								if (partItemList[i].gstRate === GST28) {
									setGSTRate28(true);
								}
								if (partItemList[i].gstRate === GST18) {
									setGSTRate18(true);
								}
								if (partItemList[i].gstRate === GST12) {
									setGSTRate12(true);
								}
								if (partItemList[i].gstRate === GST5) {
									setGSTRate5(true);
								}
							}
							let updateItemList = [...partItemList];

							for (let i = 0; i < updateItemList.length; i++) {
								grandTotal = parseFloat(grandTotal) + parseFloat(updateItemList[i].grandTotal);
								grandTotal = grandTotal.toFixed(2);
								estTotal = parseFloat(estTotal) + parseFloat(updateItemList[i].grandTotal);
								estTotal = estTotal.toFixed(0);
								TotalCgst = parseFloat(TotalCgst) + parseFloat(updateItemList[i].cgstAmount);
								TotalCgst = TotalCgst.toFixed(2);
								TotalSgst = parseFloat(TotalSgst) + parseFloat(updateItemList[i].sgstAmount);
								TotalSgst = TotalSgst.toFixed(2);
								TotalIgst = parseFloat(TotalIgst) + parseFloat(updateItemList[i].igstAmount);
								TotalIgst = TotalIgst.toFixed(2);

								if (updateItemList[i].rate) {
									if (updateItemList[i].partNumber.code || updateItemList[i].jobCode) {
										labourCharge = parseFloat(labourCharge) + parseFloat(updateItemList[i].rate);
										if (updateItemList[i].partNumber?.consumable || updateItemList[i].jobCode?.consumable) {
											consumableCharge = parseFloat(consumableCharge) + parseFloat(updateItemList[i].rate);
										}
									} else if (updateItemList[i].partNumber.hsn) {
										pCharge = parseFloat(pCharge) + parseFloat(updateItemList[i].rate);
									}
								}
								let roundoff = grandTotal.split(".");
								if (roundoff[1] === "00") {
									temp = "0.00";
								} else if (parseInt(roundoff[1]) >= 50) {
									temp = 100 - parseInt(roundoff[1]);
									temp = `+0.${temp}`;
								} else if (parseInt(roundoff[1]) < 50) {
									temp = 100 - parseInt(roundoff[1]);
									temp = `-0.${parseInt(roundoff[1])}`;
								}
							}
							form.setFieldsValue({
								grantTotal: estTotal,
								totalInvoice: estTotal,
								partCharge: pCharge,
								labourCharge: labourCharge,
								consumableCharge: consumableCharge,
								cgst: TotalCgst,
								sgst: TotalSgst,
								igst: TotalIgst,
								roundoff: temp,
							});
							setItemList([...updateItemList, partItemData]);
						}
					}
				}
			})
			.catch((error) => {
				message.error("Unable to get Materials");
				console.error("Error on get Materials : ", error);
			});
		platformApi.get("/api/jobOrder/" + value).then((res) => {
			let { data } = res;
			if (data.code === 200) {
				let { response } = data;
				if (response.code === 200) {
					if (response.data) {
						setNewCustomer(response.data.customer && response.data.customer.id);
						setCustomer(
							response.data && response.data.customer
								? formatCustomerLabel(response.data.customer.name, response.data.customer.contacts)
								: ""
						);
						setSelectedCustomer(response.data && response.data.customer);
						setModel(response.data.vehicle && response.data.vehicle?.vehicle.id);
					}
				}
			}
		});
	};

	const addCustomerData = async (customer) => {
		await platformApi
			.post("/api/customer", customer)
			.then((result) => {
				const { data } = result;
				if (data.code === 200) {
					const { response } = data;
					if (response.code === 200) {
						setCustomer(response && response.data ? formatCustomerLabel(response.data.name, response.data.contacts) : "");
						setNewCustomer(response.data.id);
						setSelectedCustomer(response.data);
						message.success("Customer added successfully", 2);
					} else {
						message.error("Unable to add customer", 2);
					}
				} else if (data.code === 500 && data.err.code === 500) {
					message.error("Customer name already exists", 2);
				} else {
					message.error("Unable to add customer", 2);
				}
			})
			.catch((error) => {
				message.error("Unable to add customer", 2);
				console.error("Error on customer : ", error);
			});
	};

	const updateCustomerData = (customer) => {
		platformApi
			.put(`/api/customer/${customer.id}`, customer)
			.then((result) => {
				const { data } = result;
				if (data.code === 200) {
					const { response } = data;
					if (response.code === 200) {
						message.success("Customer Updated successfully", 2);
						setCustomer(response && response.data ? formatCustomerLabel(response.data.name, response.data.contacts) : "");
						setNewCustomer(response.data.id);
						setSelectedCustomer(response.data);
						// setCustomer(response.data.id)
					} else {
						message.error("Unable to update customer.", 2);
					}
				} else {
					message.error("Unable to update customer", 2);
				}
			})
			.catch((error) => {
				message.error("Unable to update customer");
				console.error("Error on Customer : ", error);
			});
	};

	const checkCustomer = () => {
		let valid = false;
		let numberDatas;
		if (customerID) {
			customer.map((item) => {
				if (item.id === customerID) {
					valid = true;
					numberDatas = item;
				}
			});
		}
		if (valid) {
			if (!numberDatas.name) {
				setSelected(numberDatas);
				setModalOpen2(true);
			} else {
				setSelected(null);
				setModalOpen2(false);
			}
		}
	};

	const partyStateCode = stateName ? String(stateName).slice(0, 2) : "";
	const branchStateCode = gst ? String(gst).slice(0, 2) : "";
	const isInterStateTaxDisplay =
		Boolean(partyStateCode) &&
		Boolean(branchStateCode) &&
		partyStateCode !== branchStateCode;

	return (
		<>
			<Form className="purchase-form">
				<Row>
					<Col span={12}>
						{selectBranch?.length < 2 ? (
							<Form.Item className="purchase-form-element" label="Branch" name="branch" required disabled={true}>
								<Input placeholder="Branch Name" className="form-input" disabled={true} value={branch.name} />
							</Form.Item>
						) : (
							<Form.Item className="purchase-form-element" label="Branch" name="branch" required>
								<Select
									dropdownStyle={{
										overflowY: "auto",
										overflowX: "hidden",
									}}
									value={branch.id}
									onChange={(id) => {
										setBranch({ id, name: "" });
									}}
									showAction={["click", "focus"]}
									showSearch
									disabled={editable}
									placeholder="Branch"
									filterOption={null}
								>
									{loginCredintials.branch.map((eachBranch) => {
										return <Select.Option key={eachBranch.id}>{eachBranch.name}</Select.Option>;
									})}
								</Select>
							</Form.Item>
						)}
					</Col>
					<Col span={12}>
						<Form.Item className="purchase-form-element" label="Invoice Date" name="invoiceDate">
							<DatePicker disabled={true} value={invoiceDate ? moment(invoiceDate) : moment()} format="DD/MM/YYYY" placeholder={moment(Date.now()).format("DD/MM/YYYY")} />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col span={12}>
						<Form.Item
							className="purchase-form-element"
							label="Invoice Number"
							name="invoiceNumber"
							required
							validateStatus={formSubmit && (validateEmptyField(invoiceNo) ? "success" : "error")}
							help={formSubmit && !validateEmptyField(invoiceNo) && "Enter Invoice Number"}
						>
							<Input placeholder="Enter invoice number" className="form-input" disabled={true} value={invoiceNo} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							className="purchase-form-element"
							label="Customer"
							name="customer"
							required
							validateStatus={formSubmit && (validateEmptyField(customerID) ? "success" : "error")}
							help={formSubmit && !validateEmptyField(customerID) && "Select Customer"}
						>
							<Select
								dropdownStyle={{
									overflowY: "auto",
									overflowX: "hidden",
								}}
								// value={editable ? editData && editData.customer.name : partyName}
								value={customerID}
								onChange={(value) => {
									handleCustomerChange(value);
								}}
								showAction={["click", "focus"]}
								showSearch
								disabled={editable}
								placeholder="Customer"
								filterOption={null}
								onSearch={(e) => {
									setNumber(e);
									if (e && !/^\d+$/.test(e.trim())) {
										message.error("Please enter a valid Mobile No.");
										setValidCustomer([]);
										return;
									}
									const search = {
										module: "customers",
										column: "phone",
										searchString: e,
										fields: ["contacts{phone,id,valid}"],
										searchColumns: ["contacts"],
										setValue: setValidCustomer,
									};
									getNumbers(search);
								}}
								notFoundContent={
									number && number.trim() !== "" && /^\d+$/.test(number.trim()) ? (
										<Button
											type="primary"
											style={{
												justifyContent: "center",
												width: "100%",
											}}
											onClick={() => setModalOpen(true)}
										>
											Add Customer
										</Button>
									) : null
								}
							>
								{customer &&
									customer.map((cus) => (
										<Select.Option key={cus.id} value={cus.id}>
											{formatCustomerLabel(cus.name, cus.contacts)}
										</Select.Option>
									))}
							</Select>
						</Form.Item>
						{customerID && temp && customer.length > 0 ? (
							<Button type="primary" style={{ width: "40%", marginLeft: "10.5rem" }} onClick={() => checkCustomer()}>
								Edit Customer
							</Button>
						) : null}
					</Col>
				</Row>
				<Row>
					<Col span={6}>
						<Form.Item className="form-element-type" label="Discount Type" name="dicountType">
							<Select
								showSearch
								showAction={["click", "focus"]}
								style={{ width: 200 }}
								disabled={editable}
								placeholder="Select Discount Type"
								onChange={(value) => setDiscountType(value)}
								value={discountType}
							>
								<Option value="At Transaction Level">At Transaction Level</Option>
								<Option value="At Item Level">At Item Level</Option>
							</Select>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item className="form-element-type" label="Discount" name="discountLevel">
							<Group
								onChange={(e) => {
									setDiscountLevel(e.target.value);
								}}
								value={discountLevel}
								disabled={editable}
							>
								<Radio value="percent"> % </Radio>
								<Radio value="rupee"> Rs </Radio>
							</Group>
						</Form.Item>
					</Col>
					{discountType === "At Transaction Level" && (
						<Col span={6}>
							<Form.Item
								className="form-element-type"
								label={discountLevel === "percent" ? "Discount Percent" : "Discount Rupee"}
								name="discountAmount"
								onChange={(e) => handleDiscountAmount(e)}
								rules={[{}]}
							>
								<Input
									disabled={editable}
									placeholder={discountLevel === "percent" ? "Discount Percent" : "Discount Rupee"}
									value={discountType === "At Transaction Level" && discountAmount !== 0 ? discountAmount : discountAmount}
								/>
							</Form.Item>
						</Col>
					)}
				</Row>
				<Table
					className="parts-invoice-table"
					rowKey={(record) => {
						record.id;
					}}
					columns={renderColumns()}
					dataSource={itemList}
					tableLayout="fixed"
					pagination={false}
					style={{ marginTop: "1rem", marginBottom: "1rem" }}
				/>
				<br />
				<Row gutter={16} className="counter-summary-row">
					<Col span={8}>
						<Form.Item className="form-element" label="Labour Charge">
							{getFieldDecorator("labourCharge", {
								rules: [
									{
										required: false,
										message: "Enter Labour Charge",
									},
								],
							})(<Input placeholder="Labour Charge" disabled={true} />)}
						</Form.Item>
						{!isInterStateTaxDisplay && (
							<Form.Item className="form-element" label="CGST">
								{getFieldDecorator("cgst", {
									rules: [
										{
											required: false,
											message: "Enter  CGST",
										},
									],
								})(<Input placeholder="CGST" disabled={true} />)}
							</Form.Item>
						)}
						<Form.Item className="form-element" label="Total Discount" name="totalDiscount" rules={[{}]}>
							<Input placeholder="Total Discount" value={totalDiscount} disabled={true} />
						</Form.Item>
					</Col>
					<Col span={8} className="counter-summary-gst">
						<Form.Item className="form-element" label="Consumable Charge">
							{getFieldDecorator("consumableCharge", {
								rules: [
									{
										required: false,
										message: "Enter Consumable Charge",
									},
								],
							})(<Input placeholder="Consumable Charge" disabled={true} />)}
						</Form.Item>
						{!isInterStateTaxDisplay && (
							<Form.Item className="form-element" label="SGST">
								{getFieldDecorator("sgst", {
									rules: [
										{
											required: false,
											message: "Enter SGST",
										},
									],
								})(<Input placeholder="SGST" disabled={true} />)}
							</Form.Item>
						)}
						<div className="gst-table">
							<Title level={4} className="gst-title">
								GST Data
							</Title>
							<GSTTable
								gst={gst}
								SGST={SGST}
								CGST={CGST}
								IGST={IGST}
								itemList={itemList}
								GSTRate18={GSTRate18}
								GSTRate28={GSTRate28}
								GSTRate5={GSTRate5}
								GSTRate12={GSTRate12}
								stateName={stateName}
								selectedCustomer={selectedCustomer}
							/>
						</div>
					</Col>
					<Col span={8}>
						<div className="invoice-totals">
						<Form.Item className="form-element" label="Part Charge">
							{getFieldDecorator("partCharge", {
								rules: [
									{
										required: false,
										message: "Enter Part Charge",
									},
								],
							})(<Input placeholder="Part Charge" disabled={true} />)}
						</Form.Item>
						{isInterStateTaxDisplay && (
							<Form.Item className="form-element" label="IGST">
								{getFieldDecorator("igst", {
									rules: [
										{
											required: false,
											message: "Enter IGST",
										},
									],
								})(<Input placeholder="IGST" disabled={true} />)}
							</Form.Item>
						)}
						<Form.Item className="form-element" label="Grand Total" name="grandTotal">
							{getFieldDecorator("grantTotal", {
								rules: [{ required: false, message: "" }],
							})(
								<Input
									disabled={editable}
									placeholder="Grand Total"
									onChange={(e) => handleGrandTotal(e)}
									onKeyUp={(e) => handleGrandTotal(e)}
									onInput={(e) => handleGrandTotal(e)}
								/>
							)}
						</Form.Item>
						<Form.Item className="form-element" label="TCS" name="tcs" onInput={(e) => handleTCS(e)} rules={[{}]}>
							<div className="tcs-fields">
								<Input disabled={editable} placeholder="TCS (%)" value={TCS} onChange={(e) => handleTCS(e)} onKeyUp={(e) => handleTCS(e)} onInput={(e) => handleTCS(e)} />
								<Input disabled={true} placeholder="TCS" value={convertedTCS} />
							</div>
						</Form.Item>
						<Form.Item
							className="form-element"
							label="Adjustments"
							name="adjustments"
							onInput={(e) => handleAdjustments(e)}
							rules={[{}]}
						>
							<Input disabled={editable} placeholder="Adjustment" value={adjustments} />
						</Form.Item>
						<Form.Item className="form-element" label="Total Invoice" name="totalInvoice" rules={[{}]}>
							{getFieldDecorator("totalInvoice", {
								rules: [{ required: false, message: "" }],
							})(
								<Input
									disabled={editable}
									placeholder="Total Invoice"
									onChange={(e) => handleTotalInvoice(e)}
									onKeyUp={(e) => handleTotalInvoice(e)}
									onInput={(e) => handleTotalInvoice(e)}
								/>
							)}
						</Form.Item>
						</div>
					</Col>
				</Row>
				<div style={{ float: "right" }}>
					<Button style={{ marginRight: "1rem" }} size="large" onClick={() => handleCancel()}>
						Cancel
					</Button>
					{initialData?.status !== "PAID" && initialData?.status !== "FEEDBACK_COMPLETED" && editData?.status !== "PAID" && editData?.status !== "FEEDBACK_COMPLETED" && (
						editable ? (
							modifyAccess && (
								<Button type="primary" size="large" disabled={btnFlag} onClick={() => onModify()}>
									Modify
								</Button>
							)
						) : (
							<Button type="primary" size="large" disabled={btnFlag} onClick={() => handleSubmit()}>
								Save
							</Button>
						)
					)}
				</div>
			</Form>
			<WrappedCustomerAddModal
				emitData={(data) => addCustomerData(data)}
				open={modalOpen}
				cusId={cusId}
				setCusId={setCusId}
				number={number}
				close={() => {
					setNumber("");
					setModalOpen(false);
				}}
				editable={true}
			/>
			<WrappedCustomerUpdateModal
				emitData={(data) => updateCustomerData(data)}
				open={modalOpen2}
				cusId={cusId}
				setCusId={setCusId}
				close={() => {
					setSelected(null);
					setModalOpen2(false);
				}}
				editable={true}
				setData={setSelected}
				data={selected}
			/>
		</>
	);
};

const WrappedInvoiceForm = Form.create()(InvoiceForm);

export default WrappedInvoiceForm;
